import { Injectable } from '@angular/core';
import { ApiUrlProvider } from './api-url.provider';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IEntity } from '../shared/models/entity';
import { IApiResult } from '../shared/models/api-result';
import { EntityCategory } from '../shared/models/entity-category';
import { Position } from '../shared/models/position';
import { IRosterSummaryLine } from '../shared/models/roster/roster-summary-line';

@Injectable({
  providedIn: 'root'
})
export class EntityService {
  constructor(
    private apiUrlProvider: ApiUrlProvider,
    private http: HttpClient
  ) { }

  getEntities(): Observable<IApiResult<IEntity[]>>{
    return this.http.get<IApiResult<IEntity[]>>(`${this.apiUrlProvider.url}/entity`);
  }

  getEntitiesByCategory(categoryId: EntityCategory): Observable<IApiResult<IEntity[]>>{
    return this.http.get<IApiResult<IEntity[]>>(`${this.apiUrlProvider.url}/entity/${categoryId}`);
  }

  /**
   * @returns This API only returns active workgroup
   */
  getGroups(): Observable<IApiResult<IEntity[]>>{
    return this.http.get<IApiResult<IEntity[]>>(`${this.apiUrlProvider.url}/entity/${EntityCategory.WorkGroup}`);
  }

  /**
   * @returns This API only returns all(active/inactive) workgroup
   */
  getAllGroups(): Observable<IApiResult<IEntity[]>>{
    return this.http.get<IApiResult<IEntity[]>>(`${this.apiUrlProvider.url}/entity/all/${EntityCategory.WorkGroup}`);
  }

  getShifts(): Observable<IApiResult<IEntity[]>>{
    return this.http.get<IApiResult<IEntity[]>>(`${this.apiUrlProvider.url}/entity/${EntityCategory.WorkShift}`);
  }

  getPositions(): Observable<IApiResult<Position[]>>{
    return this.http.get<IApiResult<Position[]>>(`${this.apiUrlProvider.url}/entity/positions`);
  }

  addEntity(entity: IEntity): Observable<IApiResult<IEntity>>{
    return this.http.post<IApiResult<IEntity>>(`${this.apiUrlProvider.url}/entity`, entity);
  }

  updateEntity(entity: IEntity): Observable<IApiResult<IEntity>>{
    return this.http.post<IApiResult<IEntity>>(`${this.apiUrlProvider.url}/entity/${entity.id}`, entity);
  }

  deleteEntity(entityId: number): Observable<IApiResult<string>>{
    return this.http.post<IApiResult<string>>(`${this.apiUrlProvider.url}/entity/${entityId}/delete`, null);
  }

  //////////////////////////////////////////////////
  // getJobTypes(): Observable<IJobType[]>{
  //   return this._getEntities<IJobType[]>("jobTypes");
  // }

  // getProjectStatuses(): Observable<ProjectStatus[]>{
  //   return this._getEntities<ProjectStatus[]>("projectStatuses");
  // }

  // getAreas(): Observable<IArea[]>{
  //   return this._getEntities<IArea[]>("areas");
  // }

  // getClientEngineers(): Observable<IClientEngineer[]>{
  //   return this._getEntities<IClientEngineer[]>("clientEngineers");
  // }

  // getResponsibleEngineers(): Observable<Employee[]>{
  //   return this._getEntities<Employee[]>("responsibleEngineers");
  // }

  // getInstallationProgresses(): Observable<IInstallationProgress[]>{
  //   return this._getEntities<IInstallationProgress[]>("installationProgress");
  // }

  // private _getEntities<T>(entityName): Observable<T>{
  //   return this.http.get<T>(`http://localhost:3000/${entityName}`);
  // }

  // getGroups(): Observable<IEntity[]>{
  //   return this.http.get<IEntity[]>(`http://localhost:3000/groups`);
  // }

  getTicketStatuses(): Observable<IEntity[]>{
    return this.http.get<IEntity[]>(`http://localhost:3000/ticketstatuses`);
  }




  getRosterSummaryLines(): Observable<IRosterSummaryLine[]>{
    return this.http.get<IRosterSummaryLine[]>(`http://localhost:3000/rostersummarylines`);
  }
}

